export const backend_server = {
	"server": 		"https://pemt-dev-api.mondas.io",
	"websocket": 	"wss://pemt-dev-api.mondas.io",
	"sync_active": 	true
}

export default backend_server